import { render, staticRenderFns } from "./RelacaoContratacoesEntregasGestor.vue?vue&type=template&id=41cd58cc"
import script from "./RelacaoContratacoesEntregasGestor.vue?vue&type=script&lang=js"
export * from "./RelacaoContratacoesEntregasGestor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports